module.exports = __webpack_public_path__ + "assets/img/kv-c2c25a22.jpg";